(function () {
  const SELECTOR_ROOT = ".valetine-toggle-main[data-section-id], .valentine-toggle-main[data-section-id]";
  const SELECTOR_TOGGLE = ".js-vt-toggle";
  const SELECTOR_CARD = ".vt-card";
  const SELECTOR_SECTIONS = 'section.valentine-sections[data-group]';

  function getHeaderOffset() {
    const docRoot = document.documentElement;
    const styles = getComputedStyle(docRoot);

    const cssHeader =
      parseInt(styles.getPropertyValue("--headerHeight"), 10) ||
      parseInt(styles.getPropertyValue("--cart-sticky-offset"), 10) ||
      0;

    if (cssHeader) return cssHeader;

    // ✅ fallback to actual header height if variable missing
    const header =
      document.querySelector("#HeaderWrapper") ||
      document.querySelector("#SiteHeader") ||
      document.querySelector("header");

    return header ? header.getBoundingClientRect().height : 0;
  }

function scrollToSection(selector) {
  if (!selector) return;
  const el = document.querySelector(selector);
  if (!el) return;

  const docRoot = document.documentElement;

  const headerOffset =
    parseInt(getComputedStyle(docRoot).getPropertyValue("--headerHeight"), 10) ||
    parseInt(getComputedStyle(docRoot).getPropertyValue("--cart-sticky-offset"), 10) ||
    0;

  const EXTRA_TOP_SPACE = window.innerWidth < 750 ? 26 : 40;

  const top =
    el.getBoundingClientRect().top +
    window.scrollY -
    headerOffset -
    EXTRA_TOP_SPACE;

  window.scrollTo({
    top,
    behavior: "smooth",
  });
}

  function toggleSections(group) {
    document.querySelectorAll(SELECTOR_SECTIONS).forEach((section) => {
      const sGroup = (section.dataset.group || "").trim();
      const isMatch = sGroup === group;

      section.classList.toggle("show-section", isMatch);
      section.classList.toggle("hide-section", !isMatch);
    });
  }

  function setActiveCard(root, activeEl) {
    console.log(activeEl,'activeEl>>');
    root.querySelectorAll(SELECTOR_CARD).forEach((c) => c.classList.remove("is-active"));
    if (activeEl) activeEl.classList.add("is-active");
  }

  function initToggle(root) {
    if (!root || root.dataset.vtInited === "1") return;
    root.dataset.vtInited = "1";

    const toggles = root.querySelectorAll(SELECTOR_TOGGLE);
    const defaultGroup = (root.getAttribute("data-default-group") || "for_her").trim();

    if (!toggles.length) return;

    toggles.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const group = (link.getAttribute("data-target-group") || "").trim();
        const scrollTarget = link.getAttribute("data-scroll-target");

        if (!group) return;

        setActiveCard(root, link);
        toggleSections(group);
        scrollToSection(scrollTarget);
      });
    });

    // Init default: pick matching toggle or first toggle
    const defaultToggle =
      root.querySelector(`${SELECTOR_TOGGLE}[data-target-group="${defaultGroup}"]`) ||
      root.querySelector(SELECTOR_TOGGLE);

    const initGroup = (defaultToggle?.getAttribute("data-target-group") || defaultGroup).trim();

    setActiveCard(root, defaultToggle);
    toggleSections(initGroup);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initToggle);
  }

  // First load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify editor support
  document.addEventListener("shopify:section:load", (e) => {
    if (!e || !e.target) return;

    // Init newly loaded section
    e.target.querySelectorAll(SELECTOR_ROOT).forEach(initToggle);

    // Re-apply currently active group (global)
    const active =
      document.querySelector(`${SELECTOR_ROOT} ${SELECTOR_TOGGLE}.is-active`) ||
      document.querySelector(`${SELECTOR_ROOT} ${SELECTOR_TOGGLE}`);

    if (active) {
      const group = (active.getAttribute("data-target-group") || "for_her").trim();
      toggleSections(group);
    }
  });
})();